import { faAddressCard, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";
import SpinnerComponent from "../../../../../Components/Loding/Spinner";
import Table from "../../../../../Components/Table";
import { useAtedimento } from "../../../../../Context/Atendimento";
import {
    ListarTelefoneContatoController,
    VincularContatoController,
} from "../../../../../Controllers/HelpDesk/Atendimento/AtendimentoControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { IContatos } from "../../../../../Interfaces/Geral/Contatos/ContatosInterfaces";
import { formatPhone } from "../../../../../Tools/FormatTools";

interface IVincularForm {
    nomeEmailCPF: string;
}
interface IVincularContatoProps {
    setShow: (show: boolean) => void;
}

export default function VincularContato(props: IVincularContatoProps) {
    const { chatAberto, updateChatAberto } = useAtedimento().HELP_DESK;

    const { register, handleSubmit, formState, setError } =
        useForm<IVincularForm>();

    const {
        value: lstContatos,
        execute: ListarTelefoneContato,
        loading: ListarTelefoneContatoLoading,
    } = useAsyncCallback(ListarTelefoneContatoController);

    function handleListarFormSubmit(formData: IVincularForm) {
        ListarTelefoneContato(formData.nomeEmailCPF);
    }

    function handleVincularFormSubmit(contato: IContatos) {
        if (chatAberto) {
            VincularContatoController(
                formatPhone(chatAberto.NumeroCliente),
                contato
            )
                .then(() => {
                    props.setShow(false);
                    updateChatAberto();
                })
                .catch(() => {
                    setError("nomeEmailCPF", {
                        message:
                            "Não foi encontrada nenhuma conta correspondente",
                    });
                });
        }
    }
    interface Iprops {
        props: IContatos;
    }

    function Compo(data: Iprops) {
        const [buttonSpinner, setButtonSpinner] = useState(false);

        return (
            <div className="">
                <div className="p-5 ">
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="d-flex flex-column flex-wrap">
                            <span className="text-muted font-weight-bold">
                                {data.props.DS_EMAIL}
                            </span>
                            <div>
                                <span className="card-title text-hover-primary font-weight-bolder font-size-h3 text-dark mb-1 mr-3">
                                    {data.props.DS_NOME
                                        ? data.props.DS_NOME.length > 40
                                            ? data.props.DS_NOME.substring(
                                                  0,
                                                  40
                                              ) + "..."
                                            : data.props.DS_NOME
                                        : ""}
                                </span>
                                {data.props.NR_CPF ? (
                                    <span
                                        className="label label-light-primary label-inline "
                                        style={{ height: "auto" }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faAddressCard}
                                            className="mr-1"
                                        />{" "}
                                        {data.props.NR_CPF}
                                    </span>
                                ) : (
                                    <div></div>
                                )}
                            </div>
                            {data.props.DS_CONTA &&
                            data.props.DS_NOME !== data.props.DS_CONTA ? (
                                <span style={{ height: "auto" }}>
                                    <div className="label label-inline">
                                        <FontAwesomeIcon
                                            icon={faUser}
                                            className="mr-1"
                                        />
                                        {data.props.DS_CONTA}
                                    </div>
                                </span>
                            ) : (
                                <div></div>
                            )}
                        </div>
                        <div className="d-flex flex-column flex-wrap">
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => {
                                    setButtonSpinner(true);
                                    handleVincularFormSubmit(data.props);
                                }}
                            >
                                {buttonSpinner === true ? (
                                    <div className="loading-component">
                                        <div
                                            className="spinner-border spinner-border-sm text-light"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Carregando...
                                            </span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="toClick-component">
                                        Vincular
                                    </div>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function RowTable(cell: any, row: IContatos) {
        return <Compo props={row} />;
    }
    const ColumnEmail: Array<ColumnDescription> = [
        {
            dataField: "DS_EMAIL",
            text: "Email",
            formatter: RowTable,
            sort: true,
            isDummyField: true,
            headerClasses: "d-none",
        },
    ];

    return (
        <>
            <div className="text-center mb-10 mb-lg-20">
                <h2 className="font-weight-bold">Vincular Número a Contato</h2>
                <p className="text-muted font-weight-bold">
                    Entre com o nome, e-mail ou cpf do contato
                </p>
            </div>
            <form
                className="form"
                id="kt_login_signin_form"
                onSubmit={handleSubmit(handleListarFormSubmit)}
            >
                <div className="form-group border-bottom py-3 b-5">
                    <div className="d-flex flex-inline justify-content-center align-items-center">
                        <input
                            className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                formState.errors.nomeEmailCPF && "is-invalid"
                            }`}
                            type="text"
                            placeholder="Nome, E-mail ou CPF"
                            name="nomeEmailCPF"
                            ref={register({
                                required: "Insira algum dos dados do contato",
                            })}
                            autoComplete="off"
                        />

                        <button
                            type="submit"
                            id="kt_login_signin_submit"
                            className="btn btn-success font-weight-bold px-6 py-3 my-2"
                        >
                            Buscar
                        </button>
                    </div>
                    <div className="invalid-feedback">
                        {formState.errors.nomeEmailCPF
                            ? formState.errors.nomeEmailCPF.message
                            : ""}
                    </div>
                </div>
            </form>

            <div className="pt-2 pb-0 mt-n3">
                {lstContatos !== undefined ? (
                    !ListarTelefoneContatoLoading ? (
                        <div className="table-responsive-sm">
                            <Table
                                keyField="ID_CONTATO"
                                data={lstContatos}
                                columns={ColumnEmail}
                                noSearch
                                bordered={false}
                                sizePerPage={5}
                                noDataIndication={() => (
                                    <div className="text-center">
                                        Não foi encontrado nenhum contato
                                    </div>
                                )}
                            />
                        </div>
                    ) : (
                        <SpinnerComponent />
                    )
                ) : (
                    <div></div>
                )}
            </div>
        </>
    );
}
